import React, {useContext, useMemo} from "react";
import './ProjectStrategy.scoped.scss';
import ProjectDropdown from "../ProjectDropdown";
import {useMountAnimation, useWindowWidth} from "../hooks";
import {cn, resultIf} from "../../../../utils";
import {DetailedProjectContext} from "../DetailedProjectContext/DetailedProjectContext";
import DetailedProjectHtml from "../DetailedProjectHtml";
import DetailedProjectNavigation from "../DetailedProjectNavigation";
import {hasCollateralInfo} from "../../../../utils/pages";

const ProjectStrategy = () => {
  const project = useContext(DetailedProjectContext).project;
  const mounted = useMountAnimation();
  const isMobile = useWindowWidth();

  const strategy = useMemo(() => {
    return project.information !== null && <div className={cn("project-legal", resultIf(mounted, "mounted"))}>
      <DetailedProjectHtml translations={project.information.strategyContent} />
    </div>;
  }, [mounted]);

  if (!hasCollateralInfo(project)) return null;

  return (
    <div className="project-strategy-container">
      { isMobile ?
        <ProjectDropdown header="Стратегия взыскания">
          { strategy }
        </ProjectDropdown>
        : <>
          <div className="detailed-project__header">
            <DetailedProjectNavigation />
          </div>
          <div className="detailed-project__content">
            { strategy }
          </div>
        </> }
    </div>
  );
};

export default ProjectStrategy;